import { IA_KEY } from 'helpers/ia-logic';
import { PAGE_LAYOUT_VARIANT } from 'features/App';

import SmartRate from './SmartRate';
import { watchSmartRate } from './SmartRate.saga';

export default [
  {
    path: '/smartrate/:venueId',
    component: SmartRate,
    iaKey: IA_KEY.SMART_RATE,
    pathSagas: [watchSmartRate],
    locationSagas: [],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
  },
];
